import React from 'react'
import EditableComponent from './EditableComponent'
import { DatePicker } from '@/components/DatePicker'
import { formatDate } from '@/utils/dateUtilities'

class YearlyDatePicker extends EditableComponent {
  renderControl () {
    const { dateValue, disabled } = this.props
    if (this.isEdited()) {
      return (
        <DatePicker
          disabled={disabled}
          value={dateValue}
          onChange={value => this.props.onDateValueChange(value)} />)
    } else {
      return this.renderReadOnlyText(formatDate(dateValue))
    }
  }
}

export default YearlyDatePicker



// WEBPACK FOOTER //
// ./src/components/Editors/YearlyDatePicker.js